import { Typography, type TypographyProps } from '@mui/material';

export type DataGridTitleProps = TypographyProps;

export const DataGridTitle = (props: DataGridTitleProps) => <Typography variant="Title/medium" px={1} {...props} />;
